import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { NavDropdown, Spinner } from "react-bootstrap";
import NotificationIcon from "assets/images/svg/notification_nav.svg";
import More from "assets/images/svg/more.svg";
import { useNotifications, useNotificationsLength } from "hooks/useNotifications";
import { NotificationCard } from "./components/notification-card";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import styled from "@emotion/styled";
import { useRecoilState } from "recoil";
import { NotiFilterAtom } from "services/notifications-services";
import NoData from "components/noData/noData";
import InfiniteScroll from "react-infinite-scroller";

const NotificationBox = () => {
  const { t } = useTranslation("home");
  const [filters, setFilters] = useRecoilState(NotiFilterAtom);
  const { notiList, totalCount, fetchNextPage, isSuccess, isLoading, hasNextPage } = useNotifications();
  const { notiLength } = useNotificationsLength();
  const [value, setValue] = React.useState("2");
  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === "2") {
      setFilters({
        ...filters,
        maxResultCount: 10,
        filter: '{ isRead: { operator: "Equals", value: false },isHide:{"operator":"Equals","value":false}}'
      });
    } else {
      setFilters({ ...filters, maxResultCount: 10, filter: '{isHide:{"operator":"Equals","value":false}}' });
    }
  };

  const loadFunc = () => {
    if (!isLoading && hasNextPage) {
      fetchNextPage({ pageParam: 10 });
    }
  };
  return (
    <NavDropdown
      title={
        <>
          {notiLength > 0 && <div className="notify-number"> {notiLength > 0 && notiLength}</div>}
          <img src={NotificationIcon} alt="IconProfile" />
        </>
      }
      id="basic-nav-dropdown"
      className="NotificationIcon"
    >
      <div className="notification-header">
        <h1>{t("navbar.notifications.maintitle")}</h1>
      </div>
      <div className="notification-content">
        <TabContext value={value}>
          <TabList onChange={handleChange}>
            <Tab label={t("navbar.notifications.all")} value="1" />
            <Tab label={t("navbar.notifications.unRead")} value="2" />
          </TabList>

          <TabPanelStyled value="1">
            {isSuccess && totalCount > 0 && (
              <InfiniteScroll
                pageStart={0}
                loadMore={loadFunc}
                hasMore={true}
                loader={
                  !hasNextPage ? (
                    ""
                  ) : (
                    <div className="my-center text-center" key={1}>
                      <Spinner animation="grow" variant="primary" />
                    </div>
                  )
                }
                useWindow={false}
              >
                {isSuccess && notiList?.map((page) => page?.items?.map((n) => <NotificationCard item={n} key={n?.id} />))}
              </InfiniteScroll>
            )}
            {isSuccess && !isLoading && totalCount === 0 && <NoData isDiscreption={false} />}{" "}
          </TabPanelStyled>
          <TabPanelStyled value="2">
            {isSuccess && totalCount > 0 && (
              <InfiniteScroll
                pageStart={0}
                loadMore={loadFunc}
                hasMore={true}
                loader={
                  !hasNextPage ? (
                    ""
                  ) : (
                    <div className="my-center text-center" key={2}>
                      <Spinner animation="grow" variant="primary" />
                    </div>
                  )
                }
                useWindow={false}
              >
                {isSuccess && notiList?.map((page) => page?.items?.map((n) => <NotificationCard item={n} key={n?.id} />))}
              </InfiniteScroll>
            )}
            {isSuccess && !isLoading && totalCount === 0 && <NoData isDiscreption={false} />}{" "}
          </TabPanelStyled>
        </TabContext>
      </div>
    </NavDropdown>
  );
};

export default NotificationBox;

export const TabPanelStyled = styled(TabPanel)`
  padding: 5px 0;
  max-height: 450px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: #eaecf2;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #0074d7;
  }
`;
